import { useAppDispatch } from 'store/hooks';
import { addFormItem, resetFormItem } from 'store/slices/calculatorFormSlice';
import { store } from 'store/store';

export const useFormSubmit = () => {
	const dispatch = useAppDispatch();

	const onSubmit = async (fromData: any) => {
		if (fromData) {
			Object.keys(fromData).forEach((key, index) => {
				dispatch(
					addFormItem({
						key: key,
						item: { data: fromData[key], page: index.toString() },
					})
				);
			});
		}
	};

	const resetFormField = (formFieldId: string) => {
		const form = store.getState().calculatorForm;
		if (form[formFieldId]?.data) {
			dispatch(
				resetFormItem({
					key: formFieldId,
				})
			);
		}
	};

	return { onSubmit, resetFormField };
};
